// MUI Imports
import type { Theme } from '@mui/material';

const tooltip: Theme['components'] = {
  MuiTooltip: {
    defaultProps: {
      placement: 'top',
      disableInteractive: true,
    },
    styleOverrides: {
      tooltip: ({ theme }) => ({
        fontSize: theme.typography.subtitle2.fontSize,
        maxWidth: '200px',
        lineHeight: theme.typography.subtitle2.lineHeight,
        color: 'var(--mui-palette-Tooltip-text)',
        padding: '8px 12px',
        borderRadius: '8px',
        backgroundColor:
          theme.palette.mode === 'light' ? 'rgba(39, 39, 66, 0.90)' : 'white',
      }),
    },
  },
};

export default tooltip;
